// Lib
import { classicFormatMaxTwoDigits } from '@/utils/hooks/format/useFormatNumber';

// Types
import type { ChartType } from '@/lib/analytics/charts/type';
import { SIZE_50 } from '@/lib/gridElements/size';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';

export const reactionsHistoryConfig: ChartType<typeof LineChart> = {
    title: 'chart.pinterest.reactions_history',
    tooltip: 'chart.pinterest.tooltip_reactions_history',
    margin: { left: -20, right: 25 },
    name: {
        date: 'date',
        value: 'chart.pinterest.reactions_history_name',
        avg: 'chart.pinterest.reactions_history_avg'
    },
    id: 'reactions_history',
    color: {
        value: 'red',
        avg: 'gray'
    },
    tooltipTranslation: {
        token: 'chart.pinterest.tooltip_history',
        values: ['date', 'value', 'percentage_evolution']
    },
    valueFormat: classicFormatMaxTwoDigits,
    size: SIZE_50,
    isXAxisDate: true,
    type: 'chart',
    element: LineChart
};
